import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle} from '@fortawesome/free-solid-svg-icons'


//Start ErrorMessage component code ...
export default function ErrorMessage(props) {
    const [open, setOpen] = React.useState(false);
    const [messageInfo, setMessageInfo] = React.useState(null);
    const [titleInfo, setTitleInfo] = React.useState(null);

    React.useEffect(() => {
        if (!titleInfo) {
            // Set a new snack when we don't have an active one
            setTitleInfo(props.title);
        } 
        if (!messageInfo) {
            // Set a new snack when we don't have an active one
            setMessageInfo(props.message);
            setOpen(true);
        } else if (messageInfo && open) {
            // Close an active snack when a new one is added
            setOpen(false);
        }
    }, [props.message, props.show, props.msgType, props.title]);

    const handleExited = () => {
        setMessageInfo(undefined);
    };

    return (
        <div className={props.msgType == 'error' ? "form-alert-error" : ( props.msgType == 'custom_error' ? "form-alert-error no-border" : props.msgType === 'custom_success_nb' ? "form-alert-success no-border form-alert-manager" : "form-alert-success" )}>
            <Snackbar
                key={messageInfo ? messageInfo.key : undefined}
                open={props.show}
                onClose={props.visible}
                onExited={handleExited}
                message={messageInfo ? <> 
                <div >
                    {props.msgType == 'error' ? 
                        <FontAwesomeIcon icon={faExclamationCircle} /> 
                        : props.msgType === 'custom_error' ?
                            <img src={require('../../assets/icons/custom-error.svg')} />
                            : props.msgType == 'custom_success' || props.msgType == 'custom_success_nb' ? <img src={require('../../assets/icons/saved_successfully.svg')} /> 
                        : <FontAwesomeIcon icon={faCheckCircle} />} 
                </div> 
                &nbsp; 
                <p className="parent-message">
                    {
                        titleInfo &&
                        <label className="title-message">{titleInfo}</label>
                    }
                    {
                        messageInfo && messageInfo !== '--' ?
                        <label data-testid="errMsg" className="label-message">{messageInfo}</label> 
                        : null
                    }
                    {
                        props.dataManager && props.msgType == 'custom_success_nb'? <label onClick={props.dataManager} className="title-message mange-data-popup">Manage data</label> : null
                    }
                </p>
                </> : undefined}
            />
        </div>
    );
}
//End ErrMessage component code ...
